import { CommonModule } from '@angular/common';
import { Component, Input, QueryList, ViewChildren } from '@angular/core';
import { BillEorFooterResponse } from '../../../../models/api/view/claim/financials/bills/bill-eor-footer-response';
import { EorDataMapper } from '../../../../utilities/eor-data-mapper';
import { AddressLabelComponent } from '../../../core/labels/address-label.component';
import { CardComponent } from '../../../core/panels/card.component';
import { DetailItemComponent } from '../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../core/panels/detail-panel/detail-panel.component';

@Component({
  selector: 'app-eor-explanation-section',
  standalone: true,
  imports: [
    CommonModule,
    CardComponent,
    DetailPanelComponent,
    DetailItemComponent,
    AddressLabelComponent,
  ],
  exportAs: 'eorExplanation',
  template: `
    <div class="tw-flex tw-basis-full tw-gap-4 tw-pb-3">
      <app-card
        label="Explanation of bill review"
        [expanded]="false"
        [showExpand]="true"
        theme="Light"
        class="tw-grow"
      >
        Unless otherwise stated this bill has been reviewed in accordance with
        the rules set forth by the jurisdiction governing the claim.
        <div class="tw-flex tw-gap-8 tw-pt-4">
          <div class="tw-basis-1/2">
            <app-card
              label="Questions about this explanation of review"
              class="tw-grow"
              [expanded]="true"
              [showExpand]="false"
            >
              @if (eorFooterVendorData) {
                <app-detail-panel [dataSource]="eorFooterVendorData">
                  <app-detail-item
                    label="Provider questions contact"
                    name="pqVendorName"
                  />
                  <app-detail-item
                    label="Customer service representative"
                    name="pqPerson"
                  />
                  <app-detail-item
                    label="Bill review vendor"
                    name="vendorName"
                  />
                  <app-detail-item
                    label="PPO network"
                    name="networkID"
                    labelCase="none"
                  />
                  <app-detail-item
                    label="PPO SUB network"
                    name="subNetwork"
                    labelCase="none"
                  />
                  <app-detail-item label="Phone" name="pqPhone" />
                  <app-detail-item label="Fax" name="pqFax" />
                  <app-detail-item label="Address" name="address">
                    <ng-template let-data #value>
                      <app-address-label
                        [street1]="data.address1"
                        [street2]="data.address2"
                        [city]="data.city"
                        [state]="data.state"
                        [postalCode]="data.zip"
                        [country]="data.country"
                      />
                    </ng-template>
                  </app-detail-item>
                </app-detail-panel>
              }
            </app-card>
          </div>
          <div class="tw-basis-1/2">
            <app-card
              label="For reconsiderations"
              class="tw-grow"
              [expanded]="true"
              [showExpand]="false"
            >
              @if (eorFooterReconsiderationData) {
                <app-detail-panel [dataSource]="eorFooterReconsiderationData">
                  <app-detail-item label="Contact" name="reconName" />
                  <app-detail-item label="Phone" name="reconPhone" format="p" />
                  <app-detail-item label="Fax" name="reconFax" format="p" />
                  <app-detail-item label="Address" name="address">
                    <ng-template let-data #value>
                      <app-address-label
                        [street1]="data.address1"
                        [street2]="data.address2"
                        [city]="data.city"
                        [state]="data.state"
                        [postalCode]="data.zip"
                      />
                    </ng-template>
                  </app-detail-item>
                </app-detail-panel>
              }
            </app-card>
          </div>
        </div>
      </app-card>
    </div>
  `,
})
export class EorExplanationSectionComponent {
  @Input() billEorFooter: BillEorFooterResponse | null = null;

  @ViewChildren(CardComponent) cards!: QueryList<CardComponent>;

  toggleCards(expanded: boolean) {
    if (this.cards) {
      this.cards.forEach((card) => {
        card.expanded = expanded;
      });
    }
  }

  get eorFooterVendorData() {
    return EorDataMapper.mapFooterVendorData(this.billEorFooter);
  }

  get eorFooterReconsiderationData() {
    return EorDataMapper.mapFooterReconsiderationData(this.billEorFooter);
  }
}
